export function colorParser(hex: string): string {
  const r = parseInt(hex.slice(1, 3), 16) / 255;
  const g = parseInt(hex.slice(3, 5), 16) / 255;
  const b = parseInt(hex.slice(5, 7), 16) / 255;
  return `${r.toFixed(3)},${g.toFixed(3)},${b.toFixed(3)}`;
}

export function parseColorToHex(input?: string) {
  if (!input) return`#4e46b4`;
  
  const parts = input?.split(',').map(Number);
  const toHex = (val: number) =>
    Math.round(val * 255).toString(16).padStart(2, '0').toUpperCase();

  if (parts.length !== 3 || parts.some(isNaN)) return `#4e46b4`;

  return `#${toHex(parts[0])}${toHex(parts[1])}${toHex(parts[2])}`;
}